<template>
  <div class="cell-content">
    <!-- 普通文本 -->
    <div v-if="cell.type === 'text' || !cell.type" class="text-content">
      <div v-html="cell.content"></div>
      <div v-if="cell.desc" class="desc-txt">{{ cell.desc }}</div>
    </div>

    <!-- 复选框：预览模式显示文本，编辑模式显示复选框 -->
    <div v-if="cell.type === 'checkbox'" class="checkbox-content">
      <div v-if="previewMode" class="preview-checkbox">
        {{ cell.content == "1" ? "✓" : "" }}
      </div>
      <Checkbox
        v-else
        size="large"
        :value="cell.content == '1'"
        @on-change="handleCheckboxChange"
      >
      </Checkbox>
    </div>

    <!-- 图标 -->
    <div v-if="cell.type === 'icon'" class="icon-content">
      <Icon :type="cell.icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRenderer",
  props: {
    cell: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCheckboxChange(value) {
      this.$emit("checkbox-change", {
        cell: this.cell,
        rowIndex: this.rowIndex,
        key: this.cell.key,
        value,
      });
    },
  },
};
</script>

<style  scoped>
.desc-txt {
  font-size: 12px;
  font-weight: normal;
}
/deep/ .ivu-checkbox-large .ivu-checkbox-inner {
  width: 27px !important;
  height: 27px !important;
}
/deep/ .ivu-checkbox-large .ivu-checkbox-checked .ivu-checkbox-inner:after {
  width: 9px !important;
  height: 19px !important;
  left: 7px;
  border: 3px solid #fff;
  border-top: 0;
  border-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialRangeComponents/CellRenderer.vue